import React from 'react';
import { CheckCircle, AlertCircle, Clock, XCircle, UserX, Lock, Calendar, Ban, Trash2, Home, Box, User, Hash } from 'lucide-react';
import { Apartment } from '../types/building';
import { statusColors, statusIcons, statusLabels } from '../constants/statusConfig';
import { getApartmentLabel } from '../utils/getApartmentLabel';

interface ApartmentCellProps {
  apartment: Apartment;
  onClick: (apartment: Apartment) => void;
  onDelete: () => void;
  isFullWidth?: boolean;
}

export const ApartmentCell: React.FC<ApartmentCellProps> = ({ 
  apartment, 
  onClick, 
  onDelete,
  isFullWidth = false 
}) => {
  const StatusIcon = statusIcons[apartment.status];
  const label = apartment.status === 'aborted' && apartment.abortReason
    ? `${statusLabels[apartment.status]}: ${apartment.abortReason}`
    : statusLabels[apartment.status];
  
  // Bestimme die korrekte Bezeichnung basierend auf dem Bereichstyp
  const areaLabel = getApartmentLabel(apartment);
  
  return (
    <div 
      className={`relative ${statusColors[apartment.status]} rounded-lg transition-all duration-200 hover:shadow-md group h-full`}
    >
      <button
        onClick={() => onClick(apartment)}
        className="w-full p-4 text-left h-full"
      >
        <div className="flex items-center gap-2 mb-2">
          {apartment.areaType === 'cellar' ? (
            <Box className="w-5 h-5 text-gray-600 shrink-0" />
          ) : (
            <Home className="w-5 h-5 text-gray-600 shrink-0" />
          )}
          <span className="text-lg font-bold text-gray-800 break-words">
            {areaLabel} {apartment.formattedNumber}
          </span>
        </div>
        
        <div className="flex items-center gap-2 text-gray-700">
          <StatusIcon className="w-4 h-4 shrink-0" />
          <span className="text-sm font-medium break-words">{label}</span>
        </div>

        {apartment.konzernId && (
          <div className="flex items-center gap-1 mt-2 text-sm text-gray-600">
            <Hash className="w-3.5 h-3.5 shrink-0" />
            <span className="break-words">{apartment.konzernId}</span>
          </div>
        )}

        {apartment.technician && (
          <div className="flex items-center gap-1 mt-2 text-sm text-gray-600">
            <User className="w-3.5 h-3.5 shrink-0" />
            <span className="break-words">{apartment.technician}</span>
          </div>
        )}

        {apartment.notes && (
          <div className={`text-sm text-gray-600 mt-2 ${isFullWidth ? 'line-clamp-none' : 'line-clamp-2'} break-words`}>
            {apartment.notes}
          </div>
        )}

        {apartment.lastUpdated && (
          <div className="text-xs text-gray-500 mt-2 break-words">
            Zuletzt aktualisiert: {new Date(apartment.lastUpdated).toLocaleString('de-DE')}
          </div>
        )}
      </button>
      
      <button
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
        className="absolute top-2 right-2 p-1.5 text-red-600 hover:bg-red-100 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-200"
        title="Wohnung löschen"
      >
        <Trash2 className="w-4 h-4" />
      </button>
    </div>
  );
};